import type { ThemeDefinition } from "./types";
import { hexToSrgb, hexToLinear } from "./palette";

export const basalt: ThemeDefinition = {
  label: "Basalt",
  className: "theme-basalt",
  bg: "#1c1e24",
  text: "#8898b8",
  textMuted: "rgba(136,152,184,0.55)",
  accent: "#c07050",
  glassRgb: "28,30,36",
  border: "rgba(255,255,255,0.08)",
  borderHighlight: "rgba(255,255,255,0.18)",
  separator: "rgba(136,152,184,0.18)",
  selection: "#c07050",
  selectionText: "#1c1e24",
  gridColor: "#8898b8",
  noiseOpacity: "0.05",
  gridOpacity: "0.7",
  textShadow: "0 -1px 0px rgba(255,255,255,0.1), 0 10px 0px rgba(0,0,0,0.55)",
  gpuClear: hexToSrgb("#1c1e24"),
  gpuGridLine: hexToLinear("#8898b8"),
  gpuGridAlpha: 0.7,
  gpuAxisX: hexToLinear("#c07050"),
  gpuAxisZ: hexToLinear("#8898b8"),
  axisXColor: "#c07050",
  axisZColor: "#8898b8",
  font: '"JetBrains Mono", monospace',
  fontImport: 'https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@300;400;500;600;700&display=swap',
};
